import i18n from "i18next";
import { useTranslation } from "react-i18next";
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { openNotifyModal } from './NotifyMeModal';
export default function ProductModal({
  isModalOpen,
  setIsModalOpen
}) {
  const {
    t
  } = useTranslation();
  const [hoveredStep, setHoveredStep] = useState(null);
  const navigate = useNavigate();
  return <>
      <div className={`fixed inset-0 z-[100] flex items-center justify-center p-3 sm:p-4 transition-all duration-500 ${isModalOpen ? "opacity-100 visible" : "opacity-0 invisible"}`}>
        <div className="absolute inset-0 bg-slate-950/60 backdrop-blur-md animate-fade-in" onClick={() => {
        setIsModalOpen(false);
        document.body.style.overflow = "auto";
      }}></div>
        <div className={`relative w-full max-w-4xl max-h-[92vh] md:h-[580px] bg-slate-950 md:bg-white rounded-3xl md:rounded-[2.5rem] shadow-[0_32px_120px_-20px_rgba(0,0,0,0.6)] border border-white/10 md:border-none overflow-hidden animate-zoom-in flex flex-col transition-all duration-500 ease-[cubic-bezier(0.34,1.56,0.64,1)] transform ${isModalOpen ? "translate-y-0 scale-100" : "translate-y-12 scale-95"}`}>
          
          {/* Fixed Close Button for Mobile & Desktop Accessibility */}
          <div className="absolute top-0 right-0 p-3 sm:p-4 z-[100] pointer-events-none">
            <button className="pointer-events-auto w-9 h-9 sm:w-10 sm:h-10 rounded-full bg-white/80 md:bg-white/90 backdrop-blur-md flex items-center justify-center text-slate-800 shadow-[0_8px_20px_rgba(0,0,0,0.15)] border border-slate-200/60 hover:bg-white hover:text-primary hover:rotate-90 hover:scale-110 active:scale-95 transition-all duration-300" onClick={() => {
            setIsModalOpen(false);
            document.body.style.overflow = "auto";
          }}>
              <span className="material-symbols-outlined text-lg sm:text-xl font-black">close</span>
            </button>
          </div>

          {/* Scrollable Content Container */}
          <div className="flex-1 overflow-y-auto bg-slate-50 custom-scrollbar">
            <div className="flex flex-col md:flex-row min-h-full">
              
              {/* Left Half: Primary Product Spotlight */}
              <div className="group/spotlight w-full md:w-1/2 p-6 sm:p-8 md:p-10 bg-slate-950 relative overflow-hidden flex flex-col items-center justify-center text-center shrink-0 border-b border-white/10 md:border-none">
                {/* Background Decor */}
                <div className="absolute inset-0 z-0">
                  <img src="https://images.unsplash.com/photo-1503376780353-7e6692767b70?q=80&w=2070&auto=format&fit=crop" alt={t("productmodal_attr_638")} className="w-full h-full object-cover opacity-25 mix-blend-overlay group-hover/spotlight:scale-105 transition-transform duration-[2000ms]" fetchPriority="high" />
                  <div className="absolute inset-0 bg-gradient-to-br from-slate-950 via-slate-900/90 to-primary/30"></div>
                </div>
                <div className="absolute -top-40 -right-40 w-96 h-96 bg-primary/20 rounded-full blur-[100px] pointer-events-none"></div>
                <div className="absolute -bottom-40 -left-40 w-96 h-96 bg-tertiary/20 rounded-full blur-[100px] pointer-events-none"></div>

                <div className="relative z-10 w-full flex flex-col items-center">
                  <div className="inline-flex items-center gap-1.5 bg-primary/20 backdrop-blur-md px-3.5 py-1 rounded-full text-primary-fixed-dim text-[9px] sm:text-[10px] font-bold tracking-wider uppercase mb-4 sm:mb-6 border border-primary/30 animate-pulse-glow">
                    <span className="w-1.5 h-1.5 rounded-full bg-sky-400 animate-ping"></span>
                    <span dangerouslySetInnerHTML={{
                    __html: t("productmodal_span_639")
                  }} />
                  </div>
                  <h3 className="font-headline text-2xl sm:text-3xl md:text-3xl lg:text-4xl font-extrabold text-white mb-3 sm:mb-4 leading-tight">
                    <span dangerouslySetInnerHTML={{
                    __html: t("productmodal_span_640")
                  }} />
                  </h3>
                  <p className="font-body text-slate-300 text-xs sm:text-sm mb-6 sm:mb-8 leading-relaxed max-w-sm mx-auto">
                    <span dangerouslySetInnerHTML={{
                    __html: t("productmodal_span_641")
                  }} />
                  </p>
                  
                  {/* Connected Step Visualizer with animated process paths (Consistently Horizontal across all screen sizes) */}
                  <div className="relative w-full mb-6 sm:mb-8 px-1 sm:px-4">
                    {/* Connecting Line 1 (Step 1 -> Step 2) */}
                    <div className={`absolute top-4 sm:top-5 left-[20%] sm:left-[23%] right-[55%] sm:right-[57%] z-0 overflow-hidden rounded-full transition-all duration-300 ${hoveredStep === 1 || hoveredStep === 2 ? "h-[2px] sm:h-[3px] bg-white/30 shadow-[0_0_10px_rgba(56,189,248,0.5)]" : "h-[1.5px] sm:h-[2px] bg-white/10"}`}>
                      <div className={`absolute inset-0 bg-gradient-to-r from-primary-fixed-dim/40 via-primary-fixed/80 to-sky-400/80 rounded-full animate-energy-pulse transition-opacity duration-300 ${hoveredStep === 1 || hoveredStep === 2 ? "opacity-100" : "opacity-0"}`}></div>
                    </div>

                    {/* Connecting Line 2 (Step 2 -> Step 3) */}
                    <div className={`absolute top-4 sm:top-5 left-[55%] sm:left-[57%] right-[20%] sm:right-[23%] z-0 overflow-hidden rounded-full transition-all duration-300 ${hoveredStep === 2 || hoveredStep === 3 ? "h-[2px] sm:h-[3px] bg-white/30 shadow-[0_0_10px_rgba(56,189,248,0.5)]" : "h-[1.5px] sm:h-[2px] bg-white/10"}`}>
                      <div className={`absolute inset-0 bg-gradient-to-r from-primary-fixed-dim/40 via-primary-fixed/80 to-sky-400/80 rounded-full animate-energy-pulse transition-opacity duration-300 ${hoveredStep === 2 || hoveredStep === 3 ? "opacity-100" : "opacity-0"}`}></div>
                    </div>
                    
                    <div className="grid grid-cols-3 gap-1.5 sm:gap-2 relative z-10 w-full">
                      {/* Step 1 */}
                      <div className="flex flex-col items-center group/step cursor-pointer" onMouseEnter={() => setHoveredStep(1)} onMouseLeave={() => setHoveredStep(null)}>
                        <div className="w-9 h-9 sm:w-10 sm:h-10 rounded-full bg-slate-950 border border-white/20 flex items-center justify-center text-white/80 shadow-lg group-hover/step:border-primary-fixed-dim group-hover/step:text-white group-hover/step:scale-110 hover:shadow-[0_0_15px_rgba(0,82,255,0.4)] transition-all duration-300 relative">
                          <div className="absolute -top-1 -right-1 sm:-top-1.5 sm:-right-1.5 w-3.5 h-3.5 sm:w-4 sm:h-4 rounded-full bg-primary text-white font-extrabold text-[7px] sm:text-[8px] flex items-center justify-center shadow-md border border-white/10 select-none z-20">1</div>
                          <span className="material-symbols-outlined text-base sm:text-lg">car_crash</span>
                        </div>
                        <span className="text-[7px] sm:text-[8px] font-bold text-white/50 group-hover/step:text-white/80 transition-colors uppercase tracking-widest mt-1.5 sm:mt-2 select-none text-center">{t("productmodal_text_642")}</span>
                      </div>
                      
                      {/* Step 2 */}
                      <div className="flex flex-col items-center group/step cursor-pointer" onMouseEnter={() => setHoveredStep(2)} onMouseLeave={() => setHoveredStep(null)}>
                        <div className="w-9 h-9 sm:w-10 sm:h-10 rounded-full bg-slate-950 border border-white/20 flex items-center justify-center text-white/80 shadow-lg group-hover/step:border-primary-fixed-dim group-hover/step:text-white group-hover/step:scale-110 hover:shadow-[0_0_15px_rgba(0,82,255,0.4)] transition-all duration-300 relative">
                          <div className="absolute -top-1 -right-1 sm:-top-1.5 sm:-right-1.5 w-3.5 h-3.5 sm:w-4 sm:h-4 rounded-full bg-primary text-white font-extrabold text-[7px] sm:text-[8px] flex items-center justify-center shadow-md border border-white/10 select-none z-20">2</div>
                          <span className="material-symbols-outlined text-base sm:text-lg">calculate</span>
                        </div>
                        <span className="text-[7px] sm:text-[8px] font-bold text-white/50 group-hover/step:text-white/80 transition-colors uppercase tracking-widest mt-1.5 sm:mt-2 select-none text-center">{t("productmodal_text_643")}</span>
                      </div>
                      
                      {/* Step 3 */}
                      <div className="flex flex-col items-center group/step cursor-pointer" onMouseEnter={() => setHoveredStep(3)} onMouseLeave={() => setHoveredStep(null)}>
                        <div className="w-9 h-9 sm:w-10 sm:h-10 rounded-full bg-slate-950 border border-white/20 flex items-center justify-center text-white/80 shadow-lg group-hover/step:border-primary-fixed-dim group-hover/step:text-white group-hover/step:scale-110 hover:shadow-[0_0_15px_rgba(0,82,255,0.4)] transition-all duration-300 relative">
                          <div className="absolute -top-1 -right-1 sm:-top-1.5 sm:-right-1.5 w-3.5 h-3.5 sm:w-4 sm:h-4 rounded-full bg-primary text-white font-extrabold text-[7px] sm:text-[8px] flex items-center justify-center shadow-md border border-white/10 select-none z-20">3</div>
                          <span className="material-symbols-outlined text-base sm:text-lg">payments</span>
                        </div>
                        <span className="text-[7px] sm:text-[8px] font-bold text-white/50 group-hover/step:text-white/80 transition-colors uppercase tracking-widest mt-1.5 sm:mt-2 select-none text-center">{t("productmodal_text_644")}</span>
                      </div>
                    </div>
                  </div>

                  <button className="relative w-full py-3.5 sm:py-4 rounded-xl text-sm sm:text-base font-black text-white shadow-[0_0_30px_rgba(0,82,255,0.3)] group/btn overflow-hidden transition-all duration-300 hover:scale-[1.02] active:scale-[0.98] mb-3 sm:mb-4 bg-gradient-to-r from-primary to-primary-container hover:shadow-[0_0_40px_rgba(0,82,255,0.5)] border border-primary-fixed/20" onClick={() => {
                  setIsModalOpen(false);
                  document.body.style.overflow = "auto";
                  navigate('/products/replacement-insurance/quote');
                  window.scrollTo(0, 0);
                }}>
                    <div className="absolute inset-0 animate-shimmer-sweep pointer-events-none z-0"></div>
                    <div className="relative z-10 flex items-center justify-center gap-3">
                      <span dangerouslySetInnerHTML={{
                      __html: t("productmodal_span_645")
                    }} />
                      
                      <span className="material-symbols-outlined group-hover/btn:translate-x-1 transition-transform duration-300">arrow_forward</span>
                    </div>
                  </button>

                  <div className="flex items-center justify-center gap-2 text-white/50 text-[9px] sm:text-[10px] uppercase tracking-widest font-bold">
                    <span className="material-symbols-outlined text-xs">verified</span>
                    <span dangerouslySetInnerHTML={{
                    __html: t("productmodal_span_646")
                  }} />
                  </div>
                </div>
              </div>

              {/* Right Half: More Products (Consistently light bg-slate-50 across ALL screen sizes) */}
              <div className="w-full md:w-1/2 bg-slate-50 flex flex-col flex-1 rounded-b-3xl md:rounded-b-none md:rounded-r-[2.4rem] overflow-hidden">
                <div className="flex-1 p-6 sm:p-8 md:p-10 flex flex-col justify-between h-full">
                  <div>
                    <div className="mb-6 sm:mb-8">
                      <h4 className="font-headline text-lg sm:text-xl font-black text-slate-900 mb-1 sm:mb-2">
                        <span dangerouslySetInnerHTML={{
                        __html: t("productmodal_span_647")
                      }} />
                      </h4>
                      <p className="text-[10px] sm:text-xs text-slate-500 font-bold uppercase tracking-wider">
                        <span dangerouslySetInnerHTML={{
                        __html: t("productmodal_span_648")
                      }} />
                      </p>
                    </div>

                    <div className="space-y-3 sm:space-y-4">
                      {[{
                      icon: 'flight_takeoff',
                      titleEn: 'Travel Insurance',
                      titleFr: 'Assurance Voyage',
                      descEn: 'Global protection for trips.',
                      descFr: 'Protection pour vos voyages.'
                    }, {
                      icon: 'security',
                      titleEn: 'Cyber Insurance',
                      titleFr: 'Assurance Cyber',
                      descEn: 'Liability & digital safety.',
                      descFr: 'Sécurité et responsabilité.'
                    }, {
                      icon: 'directions_boat',
                      titleEn: 'Boat Insurance',
                      titleFr: 'Assurance Bateau',
                      descEn: 'Coverage for marine assets.',
                      descFr: 'Protection pour bateaux.'
                    }, {
                      icon: 'gavel',
                      titleEn: 'RBQ Surety Bonds',
                      titleFr: 'Cautionnements RBQ',
                      descEn: 'Construction bond solutions.',
                      descFr: 'Cautionnement construction.'
                    }].map((item, idx) => <div key={idx} onClick={() => {
                          setIsModalOpen(false);
                          document.body.style.overflow = "auto";
                          setTimeout(() => {
                            openNotifyModal();
                          }, 150);
                        }} className="bg-white p-3.5 sm:p-4 rounded-2xl flex items-center gap-3.5 sm:gap-4 group/item hover:scale-[1.02] border border-outline-variant/15 hover:border-primary/30 shadow-[0_4px_12px_rgba(0,0,0,0.03)] hover:shadow-[0_12px_30px_rgba(0,82,255,0.08)] transition-all duration-300 relative overflow-hidden cursor-pointer">
                          <div className="absolute top-2.5 sm:top-3 right-2.5 sm:right-3 flex items-center gap-1.5 px-2 sm:px-2.5 py-0.5 rounded-full bg-indigo-500/10 text-indigo-600 border border-indigo-500/20 text-[7px] sm:text-[8px] font-black uppercase tracking-wider animate-breath">
                            <span dangerouslySetInnerHTML={{
                          __html: t("productmodal_span_649")
                        }} />
                          </div>
                          <div className="w-10 h-10 sm:w-12 sm:h-12 rounded-xl bg-slate-100 flex items-center justify-center shrink-0 group-hover/item:bg-primary/10 transition-all duration-300">
                            <span className="material-symbols-outlined text-slate-600 text-lg sm:text-2xl group-hover/item:text-primary group-hover/item:scale-110 group-hover/item:rotate-3 transition-all duration-300">{item.icon}</span>
                          </div>
                          <div className="flex-1 min-w-0 pr-12">
                            <h5 className="font-headline font-bold text-xs sm:text-sm text-slate-800 group-hover/item:text-primary transition-colors duration-300 truncate">
                              <span dangerouslySetInnerHTML={{
                            __html: i18n.language?.startsWith("fr") ? item.titleFr : item.titleEn
                          }} />
                            </h5>
                            <p className="font-body text-[10px] sm:text-[11px] text-slate-500 truncate">
                              <span dangerouslySetInnerHTML={{
                            __html: i18n.language?.startsWith("fr") ? item.descFr : item.descEn
                          }} />
                            </p>
                          </div>
                        </div>)}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>;
}